import { render, staticRenderFns } from "./PermissionsReportForMes.vue?vue&type=template&id=0130452a&"
import script from "./PermissionsReportForMes.vue?vue&type=script&lang=js&"
export * from "./PermissionsReportForMes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports